let isBlog;

export const InitHeroEditor = () => {
  isBlog = document.querySelector('body').classList.contains('post-type-post');

  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=hero', initHeroClass );
  }
}


const initHeroClass = (block) => {
  const blockEl = block[0];
  if(!blockEl.tdHero){
    blockEl.tdHero = new tdHeroEditor(blockEl);
  }
}


class tdHeroEditor{
  constructor(el){
    this.blockWrap = el;
    this.block = el.querySelector('.hero');
    this.sidebar = null;
    this.active = false;
    this.pageTitle = {
      loaded : false,
      el : null,
      content : ''
    }

    this.watchForPageTitleLoad();
    
    window.addEventListener('pagetitlefound', () => {
      this.isBlog = this.block.classList.contains('blog') || document.querySelector('body').classList.contains('post-type-post');

      this.setFields();
      this.watchForActiveState();

      if(this.isBlog){
        this.updateHeroTextWithTitle();
      }
    });
  }


  /**
   * Watch click events to see if the block is selected
   * then watch for the sidebar to load before dispatching an event for other listeners.
   */
  watchForActiveState(){
    document.addEventListener('click', ()=>{
      this.active = this.blockWrap.classList.contains('is-selected');
      
      if(!this.active){
        this.sidebar = null;
        
        // Reset fields
        this.setFields();
      }
      else if(!this.sidebar){
        const sidebarSearch = setInterval(()=>{
          this.sidebar = document.querySelector('.acf-block-fields');

          if(!!this.sidebar || !this.active){
            if(!this.active){
              return;
            }

            // Sidebar found. Clear interval
            clearTimeout(sidebarSearch);

            // Trigger event for other event listeners.
            const event = new CustomEvent("sidebarfound");
            window.dispatchEvent(event);

            // Reset fields
            this.setFields();
          }
        })
      };
    });
  }


  /**
   * Watch for page title field to load
   * Once loaded, dispatch event for event listeners to use
   */
  watchForPageTitleLoad(){
    const titleInterval = setInterval(()=> {
      const postTitleField = document.querySelector('.wp-block-post-title');

      if(!!postTitleField){
        // Title Field found. Clear interval
        clearInterval(titleInterval);

        // Set title data
        this.pageTitle = {
          loaded : true,
          el : postTitleField,
          content : this.convertCO2String(postTitleField.innerHTML)
        }

        // Trigger event for other event listeners.
        const event = new CustomEvent("pagetitlefound");
        window.dispatchEvent(event);
      }
    }, 100);
  }


  /**
   * Update hero text with title for default text
   * and watch for page title change to live update
   */
  updateHeroTextWithTitle(){
    ['input','paste'].forEach( evt => 
      this.pageTitle.el.addEventListener(evt, () => {
        setTimeout(()=>{
          this.pageTitle.content = this.convertCO2String(this.pageTitle.el.innerHTML);
    
          if(!this.block.classList.contains('heading_set')){
            this.fields.heading.preview.innerHTML = this.pageTitle.content;
          }
        }, 1);
      })
    );
    

    // If a manually set hero is deleted, update to the page title 
    // THAT IS PRESENTLY SET in the page title field (not what is saved in the db)
    window.addEventListener('herofieldsloaded', () => {
      this.fields.heading.input.addEventListener('input', ()=>{
        if(!this.fields.heading.input.value){
          // Watch for the block to reload after the heading was cleared
          // Once reloaded, update to the current heading.
          const blockReloadInterval = setInterval(() => {

            if(!this.block.classList.contains('heading_set')){
              clearInterval(blockReloadInterval);
              this.fields.heading.preview.innerHTML = this.pageTitle.content;
            }
          }, 100);
        }
      });
    });
  }


  /**
   * Set fields and store them for easy useage
   */
  setFields(){
    // Currently only tracking fields that are needed for post-type "post" edit pages.
    // This could be expaned upon as needed.
    this.fields = {
      type: {
        wrapper : null,
        input : null
      },
      heading : {
        preview : this.block ? this.block.querySelector('.hero__heading') : null,
        wrapper : null,
        input : null
      }
    }

    if(this.sidebar){
      // Type
      const type = this.sidebar.querySelector('.acf-field-650b797b10dd2');
      this.fields.type.wrapper = type;
      this.fields.type.input = type.querySelector('select');

      // Heading
      const heading = this.sidebar.querySelector('.acf-field-64e5369d78812');
      this.fields.heading.wrapper = heading;
      this.fields.heading.input = heading.querySelector('textarea');

      // Set Default Values
      this.setFieldDefaultValues();

      // Dispatch event for fields loaded
      // Trigger event for other event listeners.
      const event = new CustomEvent("herofieldsloaded");
      window.dispatchEvent(event);
    }
  }


  /**
   * Set Field Default Values
   * Based on editor conditions
   */
  setFieldDefaultValues(){
    if(!this.defaultsSet){
      this.defaultsSet = true;
      
      if(this.isBlog){
        this.fields.type.input.value = 'simple';
      }
    }
  }

  /**
   * Convert 'CO2' to 'CO<sub>2</sub>'
   * 
   * @param String string - a string to search for CO2 for conversion
   * @return String - Converted or original string
   */
  convertCO2String(string){
    string = string.replaceAll('CO2','CO<sub>2</sub>');
    string = string.replaceAll('co2','CO<sub>2</sub>');
    return string;
  }
}